import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { injectGravity } from './util';
import { RootState } from 'store';

const GravityToken = () => {
  const userId = useSelector((state: RootState) => state.appConfig.userId);
  const clmUrl = useSelector((state: RootState) => state.appConfig.CLM_URL);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.origin !== clmUrl || !clmUrl) return;

      const message = event.data.message;
      if (message === 'injectGravity' && !!userId) {
        injectGravity(userId);
      }
    }

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [userId, clmUrl]);

  return null;
};

export default GravityToken;
